module.exports = __webpack_public_path__ + "static/img/2.2f3b5d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/2.jpg
// module id = OhUU
// module chunks = 6